import { more as more_1 } from './more.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

const more: RibbonButton = {
    key: 'more',
    title: () => loc(more_1),
    imageSrc: require('../svg/more.svg'),
    createDropDownCallback: () => null, // NO OP. Just need a placeholder here. Ribbon will do special handling for more button,
    darkModeIconUseInvert: true,
};

export default more;
